export default "__VITE_ASSET__CLd3Pe4x__"